var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppHeaderDropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"header"},[_c('i',{staticClass:"fa fa-user",staticStyle:{"font-size":"30px","color":"white"}})]),_vm._v("\\\n  "),_c('template',{slot:"dropdown"},[_c('b-dropdown-item',{on:{"click":_vm.logout}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Logout")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }